import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconNotebook: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconNotebook"><Path d="M4 3H8.5H20V21H8.5H4V3Z" stroke="currentColor" strokeLinecap="square"/><Path d="M8.5 3V21" stroke="currentColor" strokeLinecap="square"/><Path d="M12.5 7.5H16" stroke="currentColor" strokeLinecap="square"/><Path d="M12.5 11.5H16" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconNotebook;
